import { Slide } from "@jelly/lesson";
import config from "appConfig";

const principle: Slide = {
  title: "Measurement  of the drivers",
  layout: {
    type: "customCase040104",
    options: {
      views: {
        speaker: {
          imageUrl: `${config.ASSETS_URL}/04/case-01/slide04-speaker.svg`,
        },
        woofer: {
          imageUrl: `${config.ASSETS_URL}/04/case-01/slide04-woofer.svg`,
        },
        tweeter: {
          imageUrl: `${config.ASSETS_URL}/04/case-01/slide04-tweeter.svg`,
        },
        sensitivity: {
          eqImageUrl: `${config.ASSETS_URL}/04/case-01/slide04-sensitivity-eq.svg`,
          tasks: {
            task1: {
              correctAnswer: "91.2",
            },
            task2: {
              correctAnswer: "yes",
            },
            task3: {
              correctAnswers: [0, 1, 3],
            },
          },
        },
      },
    },
  },
};

export default principle;
